import React from 'react';
import { Link } from 'react-router-dom';
import { inject } from 'mobx-react';
import Translations from '../../stores/Translations';

interface Props {
  to: string;
  children: React.ReactNode;
  translations?: Translations;
  className?: string;
  onClick?: () => void;
  ariaLabel?: string;
  reloadDocument?: boolean;
  title?: string;
}

@inject('translations')
export default class LocalizedLink extends React.Component<Props> {
  render() {
    const {
      to,
      children,
      translations,
      className,
      onClick,
      ariaLabel,
      reloadDocument,
      title,
    } = this.props;

    const lang = translations.getLanguage();
    let toLink = to || '';
    if (!translations.isDefaultLanguage(lang)) {
      toLink = `/${lang}${toLink}`;
    }

    return (
      <Link
        to={toLink}
        className={className}
        onClick={onClick}
        aria-label={ariaLabel}
        reloadDocument={reloadDocument}
        title={title}
      >
        {children}
      </Link>
    );
  }
}
